import React, { useState, useEffect } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import './main.css';

const PongalSankrantiBanner = ({ onClose }) => {
    const [isVisible, setIsVisible] = useState(true);
    const [isHovered, setIsHovered] = useState(false);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        // Check if sticker was previously dismissed
        const dismissed = localStorage.getItem('pongal_sticker_2026_dismissed');
        if (dismissed === 'true') {
            setIsVisible(false);
        }
    }, []);

    const handleClose = (e) => {
        e.stopPropagation();
        setIsVisible(false);
        localStorage.setItem('pongal_sticker_2026_dismissed', 'true');
        if (onClose) onClose();
    };

    const handleStickerClick = () => {
        setShowModal(true);
    };

    const handleModalClose = (e) => {
        if (e) e.stopPropagation();
        setShowModal(false);
    };

    if (!isVisible) return null;

    return (
        <>
            <div
                className={`pongal-floating-sticker ${isHovered ? 'hovered' : ''}`}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                onClick={handleStickerClick}
            >


                {/* Sticker Image */}
                <img
                    src={"https://public-bucket-v3.s3.ap-south-1.amazonaws.com/pongal-idm.gif"}
                    alt="Happy Pongal & Sankranti"
                    className="pongal-sticker-image"
                />

                {/* Greeting tooltip */}
                <div className="pongal-greeting-tooltip">
                    <span className="greeting-text">Happy Pongal / Sankranti! 🌾</span>
                </div>
            </div>

            {/* Modal */}
            {showModal && (
                <div className="pongal-modal-overlay" onClick={handleModalClose}>
                    <div className="pongal-modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="pongal-modal-close" onClick={handleModalClose}>
                            <CloseOutlined />
                        </button>
                        <img
                            src={"https://public-bucket-v3.s3.ap-south-1.amazonaws.com/pongal-idm.gif"}
                            alt="Happy Pongal"
                            className="pongal-modal-image"
                        />
                        <div className="pongal-modal-text-container">
                            <div className="pongal-wishes-from">InstantDM Wishes You</div>
                            <div className="pongal-modal-title">
                                Happy Pongal <br /> &  Makar Sankranti! 🌾
                            </div>
                            <p className="pongal-modal-desc">
                                May this Festival of Harvest bring you prosperity, abundance, and sweet moments in your life.
                            </p>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default PongalSankrantiBanner;
